/**
 * !! NOTE: See index.html for global vars used by other libs like auth
 */

/**
 *  This configuration is for the last step of the integration process to pass back to the 3rd party. This is NOT for login.
 *  All configuration for Integrations OAUTH should go here. Anything in a query param for the page will
 *  override the default value. Anything in app specific configurations (eg "smartthings") will
 *  override the query parameter
 *
 *  Order of precedence
 *  1. App Configuration (defined by the app query param)
 *  2. Query Param (if it exists)
 *  3. default
 *
 */
export const URL_AFTER_PROFILE_SELECTED = "https://deako.auth0.com/authorize?"; 
export const DEAKO_URL_AFTER_PROFILE_SELECTED= "https://sso-api.deako.com/api/authorize?";
export const OAUTH_APP_CONFIG = {
    DEFAULTS: {
        audience: "deako:api",
        scope: "offline_access openid deako:api",
        response_type: "code",
        client_id: "zG2Bdzg6UFh5RvIydph2H6djdaPHNcr5",
        prompt: "none",
    },
    adc: {
        domain: "sso.deako.com",
        audience: "deako:api",
        scope: "openid email",
        response_type: "code",
        allowedConnections: [
            "google-oauth2",
            "Username-Password-Authentication",
            "apple"
        ],
        prompt: "none",
    },
    alexa: {
        domain: "sso.deako.com",
        audience: "deako:api",
        scope: "openid email",
        response_type: "code",
        allowedConnections: [
            "google-oauth2",
            "Username-Password-Authentication",
            "apple"
        ],
        prompt: "none",
    },
    googlehome: {
        domain: "sso.deako.com",
        audience: "deako:api",
        scope: "openid email",
        response_type: "code",
        allowedConnections: [
            "google-oauth2",
            "Username-Password-Authentication",
            "apple"
        ],
        prompt: "none",
    },
    smartthings: {
        redirect_uri: "https://api.smartthings.com/oauth/callback",
        domain: "sso.deako.com",
        audience: "deako:api",
        scope: "openid email",
        response_type: "code",
        allowedConnections: [
            "google-oauth2",
            "Username-Password-Authentication",
            "apple"
        ],
        prompt: "none",
    },
    smartthings_schema: {
        redirect_uri: "https://c2c-us.smartthings.com/oauth/callback",
    },

};
